export class KeyConstants {
    /* key for encryption and decryption */
    public static readonly encryptionKey = 'IHBA1631UYNAM';
}
